import { render, staticRenderFns } from "./SideBarProjectUpdates.vue?vue&type=template&id=54502776&scoped=true&"
import script from "./SideBarProjectUpdates.vue?vue&type=script&setup=true&lang=js&"
export * from "./SideBarProjectUpdates.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54502776",
  null
  
)

export default component.exports